/* ***************************************************************************
 * @author mfranco (mfranco@mobinteg.com)
 * Contains all the strings used in PL Project
 *******************************************************************************/

export const generalStrings = {
  emptyString: "",
  emptyField: "--",
  currency: " EUR",
  action: "Acção",
  preLitigation: "preLitigation",
  litigation: "litigation",
  debt: "Dívida",
  cancel: "Cancelar",
  submit: "Submeter",
  return: "Retornar",
  keep: "Guardar",
  next: "Seguinte",
  segment: "Segmento",
  ok: "ok",
  waiting: "Waiting",
  verifying: "Verificação",
  admin: "Admin",
  logout: "Logout",
  inicialPage: "Início",
  reports: "Relatórios",
  imports: "Imports",
  jobs: "Jobs",
  of: " de ",
  noResults: "Sem resultados",
  result: "Resultado",
  information: "Informação",
  client: "Cliente",
  clientNif: "NIF Client",
  privateLawyersId: "privateLawyers ID",
  lawyer: "Advogado",
  currentState: "Estado atual",
  id: "ID",
  type: "Tipo",
  subType: "Sub-tipo",
  conclusionMotive: "Motivo de conclusão",
  name: "Nome",
  addedOn: "Adicionado em",
  executedOn: "Executado em",
  languageTag: "pt",
  status: "Status",
  error: "Erro",
  complete: "Completo",
  errorFound: "...",
  email: "Email",
  password: "Password",
  currentValue: "Valor atual",
  startDate: "Data inicial",
  endDate: "Data final",
  importDate: "Data de Importação",
  creationDate: "Data de criação",
  categorizationChangeDate: "Data de alteração de categorização",
  formattedDate: "Data: ",
  date: "Data",
  value: "Valor",
  totalValue: "Valor total",
  groups: "Grupos",
  firstName: "Primeiro nome",
  lastName: "Último nome",
  confirmPassword: "Confirmar password",
  delete: "Apagar",
  debtor: "Devedor",
  debtorNif: "NIF devedor",
  cc: "Nº CC",
  nif: "Nº NIF",
  address: "Morada",
  local: "Local",
  zipCode: "CEP",
  phone: "Telefone",
  emissionDate: "Data de Emissão",
  expiryDate: "Data de Vencimento",
  state: "Estado",
  pending: "Pendente",
  paid: "Pago",
  draft: "Rascunho",
  confirmed: "Confirmado",
  sent: "Enviado",
  active: "Ativo",
  finishedSuccessfully: "Cumprido",
  finishedUnsuccessfully: "Incumprido",
  watchProcess: "Ver processo",
  settings: "Configurações",
  message: "Mensagem:",
  add: "Adicionar",
  setOfProcesses: "Conjunto de Processos",
  comment: "Comentário",
  confirm: "Confirmar",
  preview: "Pré-visualizar",
  export: "exportar",
  saveReport: "Guardar relatório",
  loading: "A carregar ...",
  details: "Detalhes",
  contactDate: "Date de contacto",
  accountNumber: "Número de conta",
  debtorType: "Tipo devedor",
  city: "Cidade",
  attachmentsAndDocuments: "Anexos e Documentação",
  expenses: "Despesas",
  company: "Empresa",
  caseId: "ID Caso",
  history: "Histórico",
  nextEvent: "Próximo evento",
  receptionDate: "Data de recepção",
  contacts: "Contactos",
  monthlyPayments: "Mensalidades",
  filter: "Filtro",
  responsibleEntity: "Entidade responsável",
  stateDate: "Data estado",
  modificationDate: "Data Modificação",
  tributeType: "Tipo de tributo",
  exercise: "Exercício",
  observations: "Observações",
  executionDetails: "Detalhes execução",
  facts: "Factos",
  interestCalculation: "Cálculo de juros",
  tasks: "Tarefas",
  paymentDate: "Data de pagamento",
  lastPayment: "Último Pagamento",
  idc: "IDC",
  categorisation: "Categorização",
  ifYouWishTransitAdicionalInjunctions:
    "Se pretender transite injunções adicionais",
  thereArentFrustraedOrUnfinishedPaymentAgreements:
    "Não é possível iniciar a execução. Isto pode aconter por várias razões",
  ruleToExecutionOne: "- Existem acordos de pagamento activos",
  ruleToExecutionTwo:
    "- Os acordos existentes devem estar num destes seguintes estados: Rascunho, Frustrado, Incumprido ou Cumprido",
  litigationEntryDate: "Data da entrada da injunção",
  citiusEntryDate: "Data de entrada no Citius",
  interestDate: "Data de juros",
  submitToCitius: "Submeter para o CITIUS",
  sendInterpolingLetter: "Enviar carta de interpelação",
  citius: "Citius",
  documentType: "Tipo de documento",
  documentNumber: "Nº Documento",
  documentCode: "Código documento",
  documentExpiryDate: "Data de validade do documento",
  inputs: "Campos",
  deletePaymentAgreement: "Apagar acordo de pagamento",
  extractPaymentAgreement: "Extrair acordo de pagamento",
  representant: "Representante",
  guarantor: "Fiador",
  mainDebtor: "Devedor principal",
  selectedDebts: "Processos selecionados",
  exportReport: "EXPORTAR RELATÓRIO",
  sendInterpellationLetter: "Enviar carta de interpelação",
  downloadStarted: "Download iniciado",
  errorDownloading: "Erro no download",
  customize: "Personalizar",
  pickAllProcesses: "Selecione todos os processos",
  itemsPerPage: "Itens por página",
  numberOfItemsPerPage: "Número de itens por página",
  contactHistoryAdded: "Histórico de contacto adicionado",
  errorAddingContactHistory: "Erro ao adicionar histórico de contacto",
  contactHistorySaved: "Histórico de contacto guardado",
  errorSavingContactHistory: "Erro ao editar histórico de contacto",
  changesSaved: "Alterações guardadas",
  errorSaving: "Erro ao guardar",
  mainDebtorSaved: "Devedor principal guardado",
  errorSavingMainDebtor: "Falha ao atualizar devedor principal",
  paymentAgreementAdded: "Acordo de pagamento criado",
  errorAddingPaymentAgreement: "Erro ao criar acordo de pagamento",
  first: "Primeiro",
  lastOne: "Último",
  previous: "Anterior",
  representantInCaseMainDebtorIsCollective:
    "Representante ( caso devedor príncipal seja entidade coletiva)",
  guarantorRepresentantInCaseGuarantorIsCollective:
    "Representante do fiador ( caso fiador seja entidade coletiva)",
  youHaveSomeFieldsMissing:
    "Tem algum dos seguintes tipos de devedores em falta:",
  invoiceValue: "Valor da fatura",
  paymentAdded: "Pagamento adicionado",
  paymentSaved: "Pagamento guardado",
  judgementDay: "Data de Julgamento (dd/mm/aaaa)",
  judgementHour: "Hora de Julgamento (hh:mm)",
  testimonyType: "Tipo de depoimento",
  witnessName: "Nome da Testemunha",
  request: "Pedido",
  requestCause: "Causa de Pedir",
  billingPhase: "Fase de faturação",
  proofDocument: "Documento Comprovativo",
  actions: "Ações",
  errorExportingReport: "Erro a exportar relatório",
  documentDeleted: "Documento apagado",
  errorDeletingDocument: "Erro a apagar documento",
  processNumber: "Número de processo",
  ignoreNotifications: "Ignorar Notificações",
};

export const login = {
  haveYouForgottenYourPassword: "Esqueceu a palavra-passe?",
  loginError: "Error login",
  login: "Login",
};

export const recoverPassword = {
  passDontMatch: "Passwords nao sao iguais",
  passChanged: "Password Alterada com sucesso",
  changePassError: "Erro ao Alterar Password",
  repeatPass: "Repetida a Password",
  changePass: "Alterar Password",
};

export const imports = {
  outrosTag: "Outros",
  edpTag: "EDP",
  importType: "Tipo de importação",
  successfullyImported: "Importados com sucesso: ",
  unsuccessfullyImported: "Importados com erro: ",
  _import: "Importação",
  uploadCtt: "Upload CTT",
  edpInjunction: "Injunção EDP",
  edpPreLitigation: "Pré Contencioso EDP",
};

export const jobs = {
  citius: "CITIUS",
  periodicCheck: "Pesquisa periódica",
  executionListUpdate: "Pesquisa Lista Pública de Execuções",
};

export const management = {
  taxManagement: "Gestão de taxas",
  userManagement: "Gestão de utilizadores",
  startDatePeriod: "Data de início de período",
  endDatePeriod: "Data final de período",
  addNewTax: "Adicionar nova taxa",
  taxAdded: "Taxa adicionada",
  errorAddingTax: "Erro ao adicionar taxa",
  interestTax: "Taxa de interesse",
  userAdded: "Utilizador adicionado",
  errorAddingUser: "Erro ao adicionar utilizador",
  userUpdated: "Utilizador atualizado",
  errorUpdatingUser: "Erro ao atualizar utilizador",
  userRemoved: "Utilizador removido",
  errorRemovingUser: "Erro ao remover utilizador",
  addUser: "Adicionar utilizador",
  groupAdded: "Grupo adicionado",
  errorAddingGroup: "Erro ao adicionar Grupo",
  addGroup: "Adicionar grupo",
  editUser: "Editar utilizador",
  checkLogs: "Ver logs",

  expenseType: "Rubrica de faturação",
  expenseTypes: "Rubricas de faturação",
  expenseTypeRemoved: "Rubrica de faturação removida",
  errorRemovingExpenseType: "Erro ao remover rubrica de faturação",
  addExpenseType: "Adicionar rubrica de faturação",
  expenseTypeUpdated: "Rubrica de faturação atualizada",
  errorUpdatingExpenseType: "Erro a actualizer rubrica de faturação",
};

export const search = {
  simpleSearchLabel:
    "Pesquisar pelo N° lote, N° interno, N° contrato, N° documento, NIF",
  advancedSearch: "Pesquisa avançada",
  search: "Pesquisar",
};

export const lot = {
  importReference: "Referência de importação",
  externalReference: "Referência externa",
  lawyerDeliveryDate: "Data de entrega ao advogado",
};

export const processes = {
  preLitigationProcedureTag: "PLP",
  litigationProcedureTag: "LP",
  executoryFormulaReference: "Referência Fórmula Executória",
  processesOf: "Processos de ",
  processes: "Processos",
  processId: "ID Processo",
  processType: "Tipo de Processo",
  processSubType: "Sub-Tipo de Processo",
  processDetails: "Detalhes do processo",
  processPhase: "Fase processual",
  phase: "Fase",
  injunctionOrExecutionNumber: "Nº de Injunção ou Execução",
  pickProcess: "Por favor selecione algum processo",
  selectProcesses: "Eleja Processos",
  toInjunction: "Passa para injunção",
  toExecution: "Passa para execução",
  preLitigation: "Pré-contencioso",
  litigation: "Contencioso",
  execution: "Execução",
  injunctions: "Injunções",
  executions: "Execuções",
  inExecution: "Em execução",
  waitingExecution: "Aguardando Execução",
  stopped: "Parado",
  value: "Valor",
  injunction: "Injunção",
  injunctionNumber: "Nº de Injunção",
  awaitsExecutionFormula: "Aguarda Fórmula Executória",
  processState: "Estado do Processo",
  processDate: "Data do Processo",
  previousInjunctions: "Injunções precedentes",
  withoutPrecedents: "Sem precedentes",
  paymentAgreement: "Acordo de Pagamentos",
  executionFormula: "Fórmulas Executórias",
};

export const debtor = {
  title: "Devedor",
  debtorNif: "NIF devedor",
  name: "Nome",
  cc: "Nº CC",
  nif: "Nº NIF",
  address: "Morada",
  local: "Local",
  zipCode: "Código Postal",
  phone: "Telefone",
  email: "Email",
  mainDebtor: "Devedor principal",
  otherDebtors: "Outros devedores",
  debtors: "Devedores",
  onAddSucess: "Devedor Adicionado",
  ccCode: "Código CC",
  ccExpiryDate: "Data de Validade CC",
  countryCode: "Código do país",
  capitalStock: "Capital Social",
};

export const invoices = {
  invoice: "Fatura",
  invoices: "Faturas",
  addedInvoices: "Faturas adicionadas",
  details: "Detalhe Processo",
  type: "Tipo de Processo",
  value: "Valor",
  emissionDate: "Data de Emissão",
  expiryDate: "Data de Vencimento",
  addInvoice: "Adicionar nova fatura",
  pickInvoice: "Por favor selecione alguma fatura",
  verifyInvoices: "Verifique e/ou Adicione faturas",
  createInvoice: "Criar Fatura",
  invoiceValue: "Valor fatura",
  invoiceNumber: "Número de fatura",
  contractSuccessfullyDeleted: "Contrato apagado com sucesso",
  invoiceSuccefullyDeleted: "Fatura apagada com sucesso",
  internalInvoiceNumber: "Número de faturação interno",
  invoiceDate: "Data de faturação",
};

export const paymentAgreements = {
  paymentAgreementTitle: "Acordo de Pagamento",
  paymentAgreementsTitle: "Acordos de pagamento",
  agreedPaymentAgreementTitle: "Acordo de pagamento",
  payments: "Prestações",
  numberOfPayments: "Nº de prestações",
  paymentNumber: "Nº de prestação",
  documentNumber: "Nº Documento",
  contractNumber: "Nº Contrato",
  contactDate: "Data de contacto",
  createContract: "Criar contrato",
  addContract: "Adicionar contrato",
  valuePerPayment: "Valor por prestação",
  limitDate: "Data limite de Pagamento",
  paymentValue: "Valor de Pagamento (€)",
  capitalValue: "Valor Capital (€)",
  actionValue: "Valor da ação",
  minActionValue: "Valor Ação (Min)",
  maxActionValue: "Valor Ação (Max)",
  agreedValue: "Valor Acordado",
  debtValue: "Valor em Dívida",
  chargedValue: "Valor cobrado",
  interestRate: "Percentagem de juros (%)",
  interestValue: "Taxa de juros",
  interest: "Juros (€)",
  interestType: "Tipo de juro",
  justiceTax: "Taxa de justiça (€)",
  firstPaymentDate: "Data limite da 1ª Prestação",
  endPaymentAgreement: "Concluir Acordo de Pagamento?",
  completePaymentAgreement: "Acordo de pagamento completo",
  citiusFinalDate: "Data final de pagamento CITIUS",
  lastJudgment: "Julgamento ou audiência final",
  preliminarHearing: "Audiência preliminar",
  creditorsMeeting: "Assembleia de credores",
  totalValue: "Valor total",
  executionNumber: "Número de execução",
  executionAgent: "Agente de execução",
  section: "Secção",
  service: "Serviço",
  court: "Tribunal",
  celebrationDate: "Data de celebração",
  createPaymentAgreement: "Criar acordo de pagamento",
  addPayment: "Adicionar Pagamento",
  payment: "Pagamento",
  defendantsNif: "NIF do Réu",
  judicialConclusionsMotive: "Motivo Conclusão Judicial",
  injunctionFileName: "Nome Ficheiro Injunção",
  judicialConclusionsDate: "Data de Conclusão Judicial",
  paymentAgreementType: "Tipo de acordo de pagamento",
  paymentAgreementStatus: "Estado de acordo de pagamento",
  singularOrCollective: "Singular/Coletivo",
  singular: "Singular",
  collective: "Coletivo",
  debtRecognition: "Reconhecimento de dívida",
  debtRecognitionByThirdParty: "Reconhecimento de dívida por terceiros",
  paymentMethod: "Método de pagamento",
  paymentRegistrationDate: "Data de registo de pagamento",
};

export const expenses = {
  expenseCount: "Número de despesas",
  addExpense: "Adicionar despesa",
  editExpense: "Editar despesa",
  errorAddingExpense: "Erro a criar despesa",
  errorDeletingExpense: "Erro a apagar despesa",
  errorUpdatingExpense: "Erro a actualizar despesa",
  errorGettingExpenseReceipt: "Erro a obter comprovativo de despesa",

  automaticExpenseRules: "Despesas automáticas",
  automaticExpenseRule: "Despesa automática",
  addAutomaticExpenseRule: "Adicionar despesa automática",
  automaticExpenseRuleAdded: "Despesa automática adicionada",
  errorAddingAutomaticExpenseRule: "Erro a adicionar despesa automática",
  automaticExpenseRuleRemoved: "Despesa automática removida",
  errorRemovingAutomaticExpenseRule: "Erro a remover despesa automática",

  expenseTypeStateTransition: "Transição de fase processual",
  expenseTypeStateTransitions: "Transições de fase processual",
  addStateTransition: "Adicionar transição",
  fromState: "Estado inicial",
  toState: "Estado final",
  stateTranstionAdded: "Transição de fase processual adicionada",
  errorAddingStateTransition: "Erro a adicionar transição de fase processual",
  stateTranstionRemoved: "Transição de fase processual removida",
  errorRemovingStateTransition: "Erro a remover transição de fase processual",
};

export const billingOrders = {
  billingOrders: "Ordens de faturação",
  billingOrder: "Ordem de faturação",

  createBillingOrder: "Criar ordem de faturação",

  CreateSteps: {
    billingOrderDetails: "Detalhes de ordem de faturação",
    pickProcesses: "Escolher processos",
    validate: "Validar",
  },

  billingOrderCreated: "Ordem de faturação criada",
  errorCreatingBillingOrder: "Erro a criar ordem de faturação",
  billingOrderUpdated: "Ordem de faturação atualizada",
  errorUpdatingBillingOrder: "Erro a atualizar ordem de faturação",
  billingReport: "Relatório faturação",
  billingProofReport: "Relatório Comprovativos",

  otherExpenses: "Outras despesas",
  expenses: "Honorários",
};

export const publicLists = {
  reason: "Motivo",
  extinctionDate: "Extinção do Processo",
  inclusionDate: "Inclusão na Lista",
  act: "Acto",
  reference: "Referência",
  insolvencyNumber: "Número de insolvência",
  type: "Espécie",
  insolvencyAdministratorNif: "NIF Administrador Insolvência",
  insolvencyAdministrator: "Administrador Insolvência",
  file: "Ficheiro",
  publicExecutions: "Execuções Públicas",
  publicInsolvencies: "PER/PEAP/insolvências Públicas",
  scheduleNewSearch: "Agendar nova pesquisa",
  contactHasNoNIF: "Este contacto nao tem NIF",
};

export const errorMessages = {
  missingFields: "Por favor preencha todos os campos",
  missingField: "Campo por preencher",
  invalidField: "Campo inválido",
  invalidValue: "Valor inválido",
  invalidDate: "Data inválida",
  missingInicialOrEndDate: "Campo obrigatório: Data inicial ou Data final",
  anErrorHasOccurred: "Ocorreu um erro",
  invalid: "Inválido",
  downloadError: "Erro a fazer download",
  notACitiusCourt: "Este tribunal não é válido para submissão no citius",
};

export const contactHistory = {
  addContact: "Adicionar contacto",
  editContact: "editar contacto",
  contactHistory: "Histórico de contactos",
};

export const execution = {
  idc: "idc",
  purpose: "Finalidade",
  court: "Tribunal",
  specie: "Espécie",
  endOfExecution: "Fim da Execução",
  executiveTitle: "Título(s) Executivo(s)",
  feReference: "Referência FE",
  injunctionNumber: "Nº de Injunção",
  address: "Morada",
  zipCode: "Código Postal",
  local: "Localidade",
  agentNumber: "Agente de Execução",
  agentRetentionModel: "Modelo retenção Agente Execução",
  iban: "IBAN",
  justiceTax: "Taxa de justiça",
  duc: "DUC",
  paymentDescription: "Descrição do pagamento",
  injunctionEntryDate: "Date da entrada da injunção",
  feOppositionDate: "Date de aposição da FE",
  capitalInDebt: "Capital em dívida",
  interestUntilLitigation: "Juros até Injunção",
  briefExposition: "Exposição sucinta",
  capitalValue: "Valor Capital",
  settlementOne: "Liquidação 1",
  settlementTwo: "Liquidação 2",
  interestFromRITillExecution: "Juros desde RI até execução",
  mandotoryInterests: "Juros compulsórios",
  totalInterest: "Total juros",
  totalValue: "Valor total",
  briefAccount: "Exposição sucinta",
  interestFromRiUntilExecution: "Juros desde RI até Execução",
  interestCompulsory: "Juros compulsórios",
  type: "Tipo",
  executionNumber: "Número de execução",
  sentenceDate: "Data da sentença",
  executionState: "Estado de execução",
  activeState: "Estado execução",
};

export const PaymentAgreementStatusTranslation = {
  Draft: "Rascunho",
  Confirmed: "Confirmado",
  Sent: "Enviado",
  Active: "Ativo",
  FinishedSuccessfully: "Cumprido",
  FinishedUnsuccessfully: "Incumprido",
  WaitingForClientsReply: "Aguarda resposta do cliente",
  WaitingForDebtorsReply: "Aguarda resposta Devedor",
  WaitingForClientsDebtorReply: "Aguarda resposta Cliente/Devedor",
  WaitingForTotalPayment: "Aguarda pagamento integral",
  Frustrated: "Frustrado",
};

export const PaymentAgreementTypeTranslation = {
  PaymentAgreement: "Acordo de pagamento",
  DebtRecognition: "Reconhecimento de dívida",
  DebtRecognitionByThirdParty: "Reconhecimento de dívida por terceiros",
};

export const BillingPhaseTranslation = {
  Initial: "Inicial",
  OnGoing: "Corrente",
  Final: "Final",
};

export const AutomaticExpenseRuleCalculationTypeTranslation = {
  Fixed: "Fixo",
  Percentage: "Percentagem",
  JusticeTax: "Taxa de justiça",
};

export const DebtPhaseTranslation = {
  PreLitigation: "Pré-Contencioso",
  Litigation: "Contencioso",
  Execution: "Execução",
};



// WEBPACK FOOTER //
// ./src/strings.jsx